import { IBillingState, ISupportState } from '../state';
import { AsyncActions } from '@telstra-connect/standard-actions';

export const initialState: Readonly<IBillingState> = Object.freeze({
    enquiry: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: []
    },
    accounts: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: []
    },
    fetchTime: new Date().getTime(),
    invoiceDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    invoiceDetailNew: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    enquiryDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    paymentDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    bans: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null,
        selectedCompanyId: null
    },
    latestInvoice: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    transactionList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    adjustmentList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    paymentTransactionDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    cidnList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    repaymentDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    adjustmentDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    usageDetailState: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    orderDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    refundAdjustmentDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    stickyFooter: {
        enquiryEnabled: false,
        selectedItems: [],
        selectedProductsCount: 0
    },
    stickyFooterUpdatedStructure: {
        enquiryEnabled: false,
        selectedItems: [],
        selectedProductsCount: 0
    },
    discountDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    enquiryCreation: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    featurePackDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    featurePackDetailLatest: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    invoiceDetailUpdatedStructure: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    stickyHeader: {
        enquiryEnabled: false,
        selectedItems: [],
        selectedProductsCount: 0,
        modalVisible: false,
        totalCount: 0
    },
    accountBalanceDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    recurringDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    invoiceDownloadStatus: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    addComment: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    fileUploads: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    activityLogs: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    caseAttachments: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    invoiceZipDownloadStatus: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    showBanner: true,
    showBadgeWrapper: true,
    showInvoiceBadgeWrapper: true,
    paymentToken: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    addDebitcardDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    ddAgreement: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    updateDirectDebitDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    },
    removeDirectDebit: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    queriedCharges: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    exportFiles: {
        csv: {
            exportQueriedCharges: {
                status: AsyncActions.AsyncActionState.NotStarted,
            },
            exportEnquiriesList: {
                status: AsyncActions.AsyncActionState.NotStarted,
            },
            exportInvoiceList: {
                status: AsyncActions.AsyncActionState.NotStarted
            }
        }
    },
    addCreditcardDetail: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    showBannerAlert: true,
    showBannerError: true,
    paymentMethods: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    closeCreditForm: true,
    editPaymentMethod: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    addPaymentMethod: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    deletePaymentMethod: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    voicePreBill: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    intMyBillInvoiceSummaryDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    intVoiceCallRecordList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    intUsageHistory: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    intUsageFilterList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    disabledDeleteIcon: {isShowInlineMsg: false, errCode: '', typeOfMethods: ''},
    intMyBillVoicePrebillServiceStatus : {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    intMyBillUsageHistoryServiceStatus : {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
})

export const supportInitialState: Readonly<ISupportState> = Object.freeze({
    userProfileDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    }
})
